import classNames from 'classnames';
import { depositStatusMap } from 'config/types';
import { observer } from 'mobx-react-lite';
import { useTenancy } from 'state';
import { ViewPayments, ViewPaymentsHeader } from '../../bricks';
import {
  ViewPaymentsDepositDetails,
  ViewPaymentsDepositPayments,
} from './bricks';
import styles from './ViewPaymentsDeposit.module.scss';

/**
 * ViewPaymentsDeposit
 *
 * @return {JSX.Element}
 */
const ViewPaymentsDeposit = ({ className }) => {
  const tenancyDoc = useTenancy();
  const { data: tenancy } = tenancyDoc;

  return (
    <ViewPayments
      className={classNames(
        styles.ViewPaymentsDeposit,
        className,
        ViewPaymentsDeposit.displayName
      )}
      header={
        <ViewPaymentsHeader
          label={`STATUS - ${
            depositStatusMap[tenancy.deposit?.status] || 'Unknown'
          }`}
          currentValue={tenancy.payments?.depositAmountPaid}
          expectedValue={tenancy.payments?.depositAmount}
        />
      }
      details={<ViewPaymentsDepositDetails />}
      payments={<ViewPaymentsDepositPayments />}
    />
  );
};

ViewPaymentsDeposit.displayName = 'ViewPaymentsDeposit';

export default observer(ViewPaymentsDeposit);
